/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useContext } from 'preact/hooks';
import { TabbableModeContext } from './TabbableModeContext';

/**
 * Utility hook for consuming the TabbableModeContext
 */
function useTabbableMode() {
  const { isTabbable } = useContext(TabbableModeContext);
  const tabbableModeProps = {
    tabIndex: isTabbable === false ? -1 : 0
  };
  return {
    isTabbable,
    tabbableModeProps
  };
}

export { useTabbableMode };
